import { useQuery } from 'data-fetching-client';
import { useCurrency } from '../context/CurrencyContext';
import { DEFAULT_PHONE_NUMBER, GET_PUBLIC_PHONE_NUMBER } from '../queries/phoneNumberQueries';
import { getBrowserLocale, getCountryCode } from '../utils/getPreferredLanguage';
import { DEFAULT_CHIRP_TIMEOUT } from '../constants/chirpDefaults';
function isCountryCode(value) {
  return typeof value === 'string' && value !== 'UNDEFINED';
}
export const usePublicPhoneNumber = ({
  skip = false
} = {}) => {
  var _data$publicPhoneNumb;
  const browserLocale = getBrowserLocale();
  const localeCountryCode = getCountryCode();
  const {
    countryCode: currencyCountryCode
  } = useCurrency();
  const preferredCountryCode = isCountryCode(localeCountryCode) ? localeCountryCode : isCountryCode(currencyCountryCode) ? currencyCountryCode : undefined;
  const {
    data,
    loading
  } = useQuery(GET_PUBLIC_PHONE_NUMBER, {
    variables: {
      browserLocale,
      preferredCountryCode
    },
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    },
    skip
  });
  const isReady = !skip && !loading;
  return {
    phoneNumber: (_data$publicPhoneNumb = data === null || data === void 0 ? void 0 : data.publicPhoneNumber) !== null && _data$publicPhoneNumb !== void 0 ? _data$publicPhoneNumb : DEFAULT_PHONE_NUMBER,
    loading: skip || loading,
    isReady
  };
};